import { render, staticRenderFns } from "./Newsbreaker.vue?vue&type=template&id=17582744"
import script from "./Newsbreaker.vue?vue&type=script&lang=js"
export * from "./Newsbreaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports